export default {"src":"/_next/static/media/Support.21f7122e.svg","height":120,"width":465,"blurWidth":0,"blurHeight":0};